module.exports = __webpack_public_path__ + "static/media/ico-seguranca.8e514a95.svg";